/**
 * Team Leader 
 */
(function ($) {

  "use strict";
  $(document).ready(function () {

    var url_current = window.location.href;
    var url = '.TeamLeaderFilters-filter';
    var domain = document.domain;

    $(url).each(function(){
      var url_full = 'http://' + domain + $(this).attr('href');
      if (url_full === url_current) {
        $(this).addClass('TeamLeaderFilters-filter--active')
      }
    })

    
  })
})
(jQuery);